import { useState, useEffect, useCallback } from 'react';
import { ref, onValue, get, set } from 'firebase/database';
import { database } from '../config/firebase';
import PropTypes from 'prop-types';

export const useUnreadNotesCount = (currentUser, selectedStudent) => {
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!currentUser || !selectedStudent) {
      setUnreadCount(0);
      return;
    }

    const studentId = selectedStudent.id;
    const teacherId = currentUser.id;

    // 既読タイムスタンプの取得と更新
    const readTimestampRef = ref(database, `teacherNotesReadTimestamp/${teacherId}/${studentId}`);

    // メモの監視
    const notesRef = ref(database, `teacherNotes/${studentId}`);
    const unsubscribe = onValue(notesRef, async (snapshot) => {
      const data = snapshot.val();
      const notesArray = data ? Object.values(data) : [];

      // 既読タイムスタンプを取得
      const readSnapshot = await get(readTimestampRef);
      const lastRead = readSnapshot.val() || 0;

      // 未読メモの数を計算
      const count = notesArray.filter(note => note.timestamp > lastRead).length;
      setUnreadCount(count);
    });

    return () => unsubscribe();
  }, [currentUser, selectedStudent]);

  // 既読マークを付ける関数
  const markAsRead = useCallback(async () => {
    if (!currentUser || !selectedStudent) return;

    const studentId = selectedStudent.id;
    const teacherId = currentUser.id;
    const readTimestampRef = ref(database, `teacherNotesReadTimestamp/${teacherId}/${studentId}`);

    try {
      await set(readTimestampRef, Date.now());
      setUnreadCount(0);
    } catch (error) {
      console.error('既読マークの更新に失敗しました:', error);
    }
  }, [currentUser, selectedStudent]);

  return { unreadCount, markAsRead };
};

useUnreadNotesCount.propTypes = {
  currentUser: PropTypes.object.isRequired,
  selectedStudent: PropTypes.object.isRequired,
};